"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = Table;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireWildcard(require("react"));
var _tableModule = _interopRequireDefault(require("./table.module.scss"));
var _BodyRow = require("../body-row/BodyRow");
var _noop = require("../../../utils/noop");
var _classnames = _interopRequireDefault(require("classnames"));
var _cells = require("../cells");
var _TableWidthMeasure = require("../table-width-measure/TableWidthMeasure");
function Table(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    testId = _ref.testId,
    pageSize = _ref.pageSize,
    noResultsComponent = _ref.noResultsComponent,
    onRowClick = _ref.onRowClick,
    _ref$createOnColumnSo = _ref.createOnColumnSort,
    createOnColumnSort = _ref$createOnColumnSo === void 0 ? function () {
      return _noop.noop;
    } : _ref$createOnColumnSo,
    sortByColumn = _ref.sortByColumn,
    innerRef = _ref.innerRef,
    horizontalScrollWidth = _ref.horizontalScrollWidth,
    _ref$hasThreeStateSor = _ref.hasThreeStateSorting,
    hasThreeStateSorting = _ref$hasThreeStateSor === void 0 ? false : _ref$hasThreeStateSor,
    _ref$BodyRowComponent = _ref.BodyRowComponent,
    BodyRowComponent = _ref$BodyRowComponent === void 0 ? _BodyRow.BodyRow : _ref$BodyRowComponent;
  var rows = (0, _react.useMemo)(function () {
    return data || Array(pageSize).fill(undefined);
  }, [data, pageSize]);
  return /*#__PURE__*/_react.default.createElement(_TableWidthMeasure.TableWidthMeasure, null, function (_ref2) {
    var measureRef = _ref2.measureRef,
      width = _ref2.width;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_tableModule.default['table'], (0, _defineProperty2.default)({}, _tableModule.default['table--overflow'], width < horizontalScrollWidth)),
      ref: measureRef
    }, /*#__PURE__*/_react.default.createElement("table", {
      className: _tableModule.default['table__container'],
      style: {
        minWidth: horizontalScrollWidth
      },
      "data-testid": testId,
      ref: innerRef
    }, /*#__PURE__*/_react.default.createElement("thead", {
      className: _tableModule.default['table__head']
    }, /*#__PURE__*/_react.default.createElement("tr", {
      className: _tableModule.default['table__header-row']
    }, columns.map(function (c) {
      var HeaderCell = c.component ? c.component.Header : _cells.TextCell.Header;
      var direction = sortByColumn && sortByColumn[c.accessor];
      var onColumnSort = c.sort ? createOnColumnSort(c.accessor) : undefined;
      if (c.sort && direction === undefined) {
        throw new Error("Specify the direction in sortByColumn for ".concat(c.accessor.toString(), " as you set sort to \"true\" for the ").concat(c.name.toString(), " column"));
      }
      return /*#__PURE__*/_react.default.createElement(HeaderCell, {
        key: c.name,
        onColumnSort: onColumnSort,
        direction: direction,
        hasThreeStateSorting: hasThreeStateSorting
      }, c.name);
    }))), /*#__PURE__*/_react.default.createElement("tbody", null, rows.length ? rows.map(function (row, index) {
      var key = row === undefined ? index : row.id;
      return /*#__PURE__*/_react.default.createElement(BodyRowComponent, {
        "data-testid": "body-row-".concat(key),
        key: key,
        row: row,
        onClick: onRowClick
      }, columns.map(function (column, index) {
        var Cell = column.component || _cells.TextCell;
        if (row === undefined) {
          return /*#__PURE__*/_react.default.createElement(Cell.Loading, {
            key: index
          });
        }
        return /*#__PURE__*/_react.default.createElement(Cell, {
          row: row,
          key: column.accessor.toString(),
          data: row[column.accessor]
        });
      }));
    }) : noResultsComponent)));
  });
}